import { render, staticRenderFns } from "./InvoiceReceiving.vue?vue&type=template&id=522a6bde&scoped=true&"
import script from "./InvoiceReceiving.vue?vue&type=script&lang=js&"
export * from "./InvoiceReceiving.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceReceiving.vue?vue&type=style&index=0&id=522a6bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a6bde",
  null
  
)

export default component.exports